import dayjs from "dayjs";
import i18n from "../../../i18n";

export const formatAddress = ({ name, address } = {}) =>
  name ? `${name} <${address}>` : address || "";

export const displayName = ({ name, address } = {}) => name || address || "";

export const formatAddressList = list => (list || []).map(formatAddress).join(", ");

// Intl follows the UI language (e.g. "22. Sept." / "Di., 22.09.2026, 12:52" in German).
const formatDate = (date, options) =>
  new Intl.DateTimeFormat(i18n.language || undefined, options).format(date);

export const formatListDate = date => {
  const value = dayjs(date);
  if (!value.isValid()) return "";
  if (value.isSame(dayjs(), "day"))
    return formatDate(value.toDate(), { hour: "2-digit", minute: "2-digit" });
  if (value.isSame(dayjs(), "year"))
    return formatDate(value.toDate(), { day: "numeric", month: "short" });
  return formatDate(value.toDate(), { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const formatFullDate = date => {
  const value = dayjs(date);
  if (!date || !value.isValid()) return "";
  return formatDate(value.toDate(), {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const formatSize = bytes => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const escapeHtml = value =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export const textToHtml = text => escapeHtml(text).replace(/\r?\n/g, "<br>");

// DOMParser documents are inert (no scripts run, no images load), unlike a detached
// element's innerHTML, so this is safe for untrusted email HTML.
export const htmlToText = html => {
  const doc = new DOMParser().parseFromString(html || "", "text/html");
  doc.querySelectorAll("br").forEach(br => br.replaceWith("\n"));
  doc.querySelectorAll("p, div, li, tr, h1, h2, h3, h4, blockquote").forEach(el => el.append("\n"));
  return (doc.body.textContent || "").replace(/\n{3,}/g, "\n\n").trim();
};

export const hasRemoteContent = html =>
  /(src|background)\s*=\s*["']?\s*https?:|url\(\s*["']?\s*https?:/i.test(html || "");

export const prefixSubject = (prefix, subject = "") => {
  const pattern = new RegExp(`^\\s*${prefix}\\s*:`, "i");
  return pattern.test(subject) ? subject : `${prefix}: ${subject}`;
};

export const sameAddress = (a, b) => (a || "").toLowerCase() === (b || "").toLowerCase();

export const folderIconKey = folder =>
  folder?.specialUse || (folder?.path === "INBOX" ? "\\Inbox" : "folder");
